var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bouton"},[_c('button',{on:{"click":_vm.changeLanguage}},[_c('span',{staticClass:"flag-icon",class:{ 'flag-fr': _vm.$i18n.locale === 'fr', 'flag-en': _vm.$i18n.locale === 'en' }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }